import React, { useEffect, useState } from 'react'
import { FaAngleLeft } from "react-icons/fa6";
import { SlHome } from "react-icons/sl";
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';
import { Link } from 'react-router-dom';
import { getFavorite } from '../Services/Operations/ProductAPI';

const FavoritePage = () => {
    const navigation = useNavigate();
    const location = useLocation();
    const [favorite, setFavorite] = useState([]);
    const { longitude, latitude } = location.state || {};
    const token = useSelector((state) => state.user.token);
    const BASE_URL = "https://zotpot.in";
    console.log("latitude : ", latitude)
    console.log("longitude : ", longitude)

    useEffect(() => {
        const fetchFavorite = async () => {
            try {
                const formData = new FormData();
                formData.append("token", token);
                formData.append("latitude", latitude);
                formData.append("longitude", longitude);

                for (let pair of formData.entries()) {
                    console.log(`${pair[0]}: ${pair[1]}`);
                }

                const response = await getFavorite(formData);
                if (response) {
                    console.log("Favorite Data:", response);
                    setFavorite(response)
                }

            } catch (error) {
                console.error("Error fetching profile or pages:", error);
            }
        };

        fetchFavorite();
    }, [token]);

    return (
        <div>
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "100%",
                    maxWidth: "770px",
                    margin: "auto"
                }}
            >
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", }}>
                    <FaAngleLeft onClick={() => navigation(-1)} />
                    <p style={{ marginLeft: "23px" }}>My Favourite Stores</p>
                </div>
                <div style={{ display: "flex", gap: "20px", marginRight: "13px" }}>
                    <Link to="/"><SlHome /></Link>
                </div>
            </div>
            {favorite.map((item) => (
                <div style={{ height: "109px" }} className="store-item" key={item.id}>
                    <img style={{ width: "111px" }} src={`${BASE_URL}${item.image}`} alt={item.name} />
                    <div
                        style={{
                            marginLeft: "20px",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-between",
                            alignItems: "flex-start",
                            position: "relative"
                        }}
                    >
                        <h3 style={{ margin: "0px", textAlign: "left", width: "86%" }}>{item.name}</h3>
                        <p style={{ margin: "0px", textAlign: "left" }}>{item.description}</p>
                        <div className="store-details">
                            <span>{item.rating}</span>
                            <span>{item.delivery_time} min</span>
                            <span>{item.price_range}rs</span>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    )
}

export default FavoritePage
